import { Component, inject, OnInit, signal, WritableSignal } from '@angular/core';
import { OpenService } from '../../../services/open-service';
import { FaqBlock } from '../../../models/FaqBlock';
import { ToastrService } from 'ngx-toastr';
import { AccordionItem } from '../../common/accordion-item/accordion-item';
import { FaqCategory } from '../../../models/FaqCategory';
import { Hero } from '../../common/hero/hero';

@Component({
  selector: 'app-faq-page',
imports: [AccordionItem, Hero],
  templateUrl: './faq-page.html',
  styleUrl: 'faq-page.scss',
})
export class FaqPage implements OnInit {

  private openService = inject(OpenService);
  private toastrService = inject(ToastrService);
  
  faqBlocks: WritableSignal<FaqCategory[]> = signal([]);
  currentsOpen = signal<string[]>([]);

  ngOnInit(): void {
    this.openService.getFaqData().then(
      dto => this.faqBlocks.set(dto.FAQ)
    ).catch(() => this.toastrService.error("Erreur de récupération de la FAQ"))
  }

  setCurrentOpen(value: string): void {
    this.currentsOpen.set([...this.currentsOpen()!, value]);
  }

  closeCurrentOpen(value: string): void {
    if (this.currentsOpen() !== null) {
      this.currentsOpen.set(this.currentsOpen()!.filter(
        opened => opened !== value
      ));
    }
  }

}
